import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScriptsService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  addScript(attributes: { src: string; [key: string]: string }, properties: { [key: string]: any } = {}): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const script = document.createElement('script');
    const attrKeys = Object.keys(attributes);
    for (const key of attrKeys) {
      script.setAttribute(key, attributes[key]);
    }
    const propsKeys = Object.keys(properties);
    for (const propKey of propsKeys) {
      script[propKey] = properties[propKey];
    }
    document.body.appendChild(script);
  }
}
